(function ($) {
  DJ.addBehavior('footerNavigationDropdown', '.footer-navigation--mobile .footer-navigation-section', {
    attach: function () {
      const section = this;
      const dropdownBtn = section.querySelector('.footer-navigation-section__title');
      const openedClass = 'footer-navigation-section--opened';

      dropdownBtn.addEventListener('click', (e) => {
        if (!section.classList.contains(openedClass)) {
          e.preventDefault();
          $(this).closest('.footer-navigation').find('.footer-navigation-section').removeClass(openedClass);
          section.classList.add(openedClass);
        }
      });
    }
  });
})(jQuery);
